export default __webpack_public_path__ + "static/media/um2.325ced45.svg";